import { InputText, TextBase } from '@carboncopyco/ui';
import { RulePreview } from '../RulePreview';

export const ModificationItemText = ({
  label,
  tooltipLabel,
  isEdit,
  editText,
  setEditText,
  errorMessage,
  setEditMode,
}: {
  label: string;
  tooltipLabel?: string;
  isEdit?: boolean;
  editText?: string;
  setEditText?: (value: string) => void;
  errorMessage?: string;
  setEditMode?: (value: boolean) => void;
}) => {
  return (
    <RulePreview.Tooltip
      title={tooltipLabel ?? label}
      zIndex={300}
    >
      <span className="truncate">
        {isEdit ? (
          <InputText
            size="sm"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !errorMessage) {
                setEditMode(false);
              }
            }}
            value={editText}
            onChange={(e) => {
              setEditText(e.target.value);
            }}
            state={errorMessage ? 'error' : 'normal'}
            errorTooltipMessage={errorMessage}
          />
        ) : (
          <TextBase
            label={label}
            color="text-ds-natural-600"
            ellipsis
          />
        )}
      </span>
    </RulePreview.Tooltip>
  );
};
